// eslint-disable-next-line
import util from 'util';

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import AccountSelect from './AccountSelect';
// import Statement from './Statement';
// import PaymentMethods from './PaymentMethods';
// import Plans from '../profile/Plans';
// import AddressDetails from '../profile/AddressDetails';

import * as accountSelectors from './selectors';
import * as accountActions from './actions';
import * as coreActions from '../core/actions';
import * as Formatters from '../ui/Formatters';

import DownloadIcon from '@material-ui/icons/GetApp';
import DotIcon from '@material-ui/icons/FiberManualRecord';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Confirm from '../ui/Confirm';
// import InfoIcon from '@material-ui/icons/Info';
import AddressEdit from '../core/AddressEdit';

import { withRouter } from 'react-router-dom';

const styles = theme => ({
  root: {
    padding: theme.spacing(1),
    // minHeight: '100%',
    flexGrow: 1,
    display:'flex',
  },
  contentBox: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },

  leftSide:{
    overflow:'auto',
    padding: theme.spacing(1),
    flexGrow: 1,
    // minHeight: '100%',
    display:'flex',
  },

  accountSelect: {
    // position: 'absolute',
    // top: 0,
    // left: 0,
    // right: '50%',
    // bottom: '70%',
    // marginRight: 10,
    // marginBottom: 10,
    display: 'flex',
    flex:1,
    margin: 10,
    borderRadius: 20,
    padding: 0,
  },

  phoneNumbers: {
    // position: 'absolute',
    // top: '30%',
    // left: 0,
    // right: '50%',
    // bottom: '35%',
    // marginRight: 10,
    // marginBottom: 10,
    // marginTop: 10,
    borderRadius: 20,
    margin: 10,
    padding: 0,
  },

  callerIds: {
    // position: 'absolute',
    // top: '65%',
    // left: 0,
    // right: '50%',
    // bottom: 0,
    // marginTop: 10,
    // marginRight: 10,
    // borderRadius: 20,
    margin: 10,
    padding: 0,
  },

  statement: {
    // position: 'absolute',
    // top: 0,
    // left: '50%',
    // right: 0,
    // bottom: '35%',
    margin: 10,
    borderRadius: 20,
    padding: 0,
  },

  autopay: {
    // position: 'absolute',
    // top: '65%',
    // left: '50%',
    // right: 0,
    // bottom: 0,
    // marginTop: 10,
    // marginLeft: 10,
    margin: 10,
    borderRadius: 20,
    padding: 0,
  },
  flexContainer:{

    // minHeight: '100%',
    maxWidth:'100%',
    minWidth:'100%',
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center'
  },
  flexItemRoot: {
    // these are flex items
    
    // flex: 1; same as:
    flexGrow: 1,
    // flex-shrink: 1;
    // flex-basis: auto;
    // flex: 1 1 auto;
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  flexItem: {
    // also flex items 
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  panel: {
    padding: 30,
    border:'1px solid #cccdd2',
    borderRadius: 8,
    width: '100%',
    height: '100%',
    overflow:'scroll'
  },
  emailPanel: {
    padding: 30,
    border: '1px solid #cccdd2',
    borderRadius: 8,
    height: '100%',
  },
  tooltip: {
    fontSize: 14,
    textAlign: 'center',
  },

});


/*
 * Default filler screen until the real one is implemented
 */

class Account extends Component {
  state={
    tableValue: 0,
    mouseState: 'left',
    confirmAddPaymentOpen: false,
    addressEditOpen: false,
    editType: '',
    showAllBillingEmails: false
  }

  componentDidMount(){
    document.title = 'Ruby - Billing';
    const queryParams = new URLSearchParams(this.props.location.search);
    const tab = queryParams.get('tab');
    if(parseInt(tab) < 3 && parseInt(tab) >= 0){
      this.setState({tableValue: parseInt(tab)});
    }
    
    // Load billing emails when component mounts
    if (this.props.account?.accountId) {
      this.props.queryBillingEmails();
    }
  }

  componentDidUpdate(){
    if (Array.isArray(this.props.paymentMethods.paymentMethods) && this.props.paymentMethods.paymentMethods.length > 0 &&
        this.props.paymentMethods.paymentMethods[0].accountId === this.props.account.accountId) {
      if (Boolean(this.props.account.autopayPaymentMethodUid)){
        if (!Boolean(this.props.paymentMethods.paymentMethods.find(m => m.id === this.props.account.autopayPaymentMethodUid))) {
          this.props.enableAutopay(this.props.account.accountId, this.props.paymentMethods.paymentMethods[0].id);
        }
      }
    }
  }

  handleChange = (event, newValue) => {
    this.setState({tableValue: newValue});
  };

  invoiceClicked = (invoiceId) => {
    this.props.setInvoiceOpen(true);
    this.props.queryPaymentMethods(this.props.account.accountId);
    this.props.queryInvoice(this.props.account.accountId, invoiceId);
  }

  render() {
    const { classes, account, paymentMethods, downloadPdfInvoice, enableAutopay, deletePaymentMethod } = this.props;

    // return (<MuiCore.Grid container className={classes.root} spacing={2}>
    //       <MuiCore.Grid item lg={6} md={12} className={classes.flexContainer} >
            

    //       <MuiCore.Grid container className={classes.leftSide} spacing={2}>
    //         <AccountSelect className={classes.flexItemRoot} />
    //         <PhoneNumbers className={classes.flexItemRoot}  />
    //         <CallerIds  className={classes.flexItemRoot}  />
    //       </MuiCore.Grid>
    //             {/* <div className={classes.accountSelect}>
    //               <AccountSelect />
    //             </div>
             
    //             <div className={classes.phoneNumbers}>
    //               <PhoneNumbers />
    //             </div>
              
    //             <div className={classes.callerIds}>
    //               <CallerIds />
    //             </div> */}
    //       </MuiCore.Grid>

    //       <MuiCore.Grid item lg={6} md={12} className={classes.flexContainer}>
           
    //           <MuiCore.Grid container className={classes.leftSide} spacing={2}>
    //             <Statement className={classes.flexItemRoot} />
  
             
    //             <PaymentMethods className={classes.flexItemRoot} />
                  
    //             </MuiCore.Grid>
             
    //       </MuiCore.Grid>
    //     </MuiCore.Grid>
      
    // );

    let allAccountProducts = [];
    account?.accountBundles?.forEach(item => {
      item?.accountProducts?.forEach(product => {
        allAccountProducts.push(product);
      })
    })

    return (
      <MuiCore.Grid container className={classes.root}>
        <Confirm open={this.state.confirmAddPaymentOpen}
          title='You are leaving this site'
          confirmLabel='OK'
          text='Clicking OK will redirect your browser to our payment processor to securely collect your payment details.'
          onCancel={() => this.setState({ confirmAddPaymentOpen: false })}
          onConfirm={() => {
            this.setState({ confirmAddPaymentOpen: false });
            this.props.redirectToAddPayment(account.accountId);
          }} />
        <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
          <MuiCore.Grid lg={6} style={{ alignSelf: 'center' }}>
            <MuiCore.Grid container className={classes.leftSide}>
              <AccountSelect className={classes.flexItemRoot} showOnlyParentAccounts />
            </MuiCore.Grid>
          </MuiCore.Grid>
        </MuiCore.Grid>
        <AddressEdit open={this.state.addressEditOpen} editType={this.state.editType} onClose={() => {
          this.setState({ addressEditOpen: false });
          setTimeout(() => {
            this.props.queryAccount();
          }, 2000)
        }} />
        <MuiCore.Grid style={{ width: '100%' }}>
          <MuiCore.Tabs value={this.state.tableValue} onChange={this.handleChange} indicatorColor="primary" centered>
            <MuiCore.Tab label="Plans" />
            <MuiCore.Tab label="Invoices" />
            <MuiCore.Tab label="Payment info" />
          </MuiCore.Tabs>
        </MuiCore.Grid>
        <div style={{ padding: "20px 0 0 0", minWidth : '100%', maxWidth:'100%' }}>
          {this.state.tableValue === 0 && <MuiCore.Grid lg={6} className={classes.flexContainer}>
            {/* <Plans className={classes.flexItemRoot} /> */}
            {account.accountBundles?.map((bundle, index) => (
              <Fragment key={index}>
                <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 24, marginBottom: 20 }}>Plan Details</MuiCore.Typography>
                <MuiCore.Grid className={classes.panel}>
                  <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 18 }}>{bundle.description}</MuiCore.Typography>
                  <MuiCore.Grid style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Start Date</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{new Date(new Date(bundle.startDate).getTime() + (10 * 60 * 60 * 1000)).toLocaleString(undefined, { month: 'numeric', day: 'numeric', year: 'numeric' })}</MuiCore.Typography>
                    </MuiCore.Grid>
                    <span><MuiCore.Divider orientation='vertical' style={{ color: '#FF0000', marginLeft: 20, marginRight: 20 }} /></span>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Price / Month</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{Formatters.formatMoney(bundle?.accountProducts?.find(p => p.bundleDescription === bundle.description && p.plan === 'Y').unitPrice, bundle.currencyCode)}</MuiCore.Typography>
                    </MuiCore.Grid>
                    <span><MuiCore.Divider orientation='vertical' style={{ color: '#FF0000', marginLeft: 20, marginRight: 20 }} /></span>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Overage Price</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{Formatters.formatMoney(bundle?.accountProducts?.find(p => p.bundleDescription === bundle.description && p.usage === 'Y').unitPrice, bundle.currencyCode)}</MuiCore.Typography>
                    </MuiCore.Grid>
                    <span><MuiCore.Divider orientation='vertical' style={{ color: '#FF0000', marginLeft: 20, marginRight: 20 }} /></span>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Quantity</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>1</MuiCore.Typography>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </Fragment>
            ))}
            {allAccountProducts?.filter(product => product.addon === 'Y').map((bundle, index) => (
              <MuiCore.Grid lg={6} style={{ alignSelf: 'center', marginTop: 20 }}>
                <MuiCore.Grid className={classes.panel}>
                  <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 18 }}>{bundle.invoiceLine}</MuiCore.Typography>
                  <MuiCore.Grid style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Start Date</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{new Date(new Date(bundle.periodStart).getTime() + (6 * 60 * 60 * 1000)).toLocaleString(undefined, { month: 'numeric', day: 'numeric', year: 'numeric' })}</MuiCore.Typography>
                    </MuiCore.Grid>
                    <span><MuiCore.Divider orientation='vertical' style={{ color: '#FF0000', marginLeft: 20, marginRight: 20 }} /></span>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Price / Month</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{Formatters.formatMoney(bundle.originalUnitPrice, bundle.currencyCode)}</MuiCore.Typography>
                    </MuiCore.Grid>
                    <span><MuiCore.Divider orientation='vertical' style={{ color: '#FF0000', marginLeft: 20, marginRight: 20 }} /></span>
                    <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 14 }}>Quantity</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>1</MuiCore.Typography>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            ))}
            {/* {Boolean(account.activeDiscountPartnerName) && <MuiCore.Grid lg={6} style={{alignSelf: 'center', marginTop: 20}}>
                    <MuiCore.Grid className={classes.panel}>
                      <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 18}}>{account.activeDiscountPartnerName}</MuiCore.Typography>
                      <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', marginTop: 20}}>
                        <MuiCore.Grid>
                          <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 14}}>Start Date</MuiCore.Typography>
                          <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 17}}>{Formatters.formatDate(account.activeDiscountPartnerStartDate)}</MuiCore.Typography>
                        </MuiCore.Grid>
                        <span><MuiCore.Divider orientation='vertical' style={{color: '#FF0000', marginLeft: 20, marginRight: 20}}/></span>
                        <MuiCore.Grid>
                          <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 14}}>Quantity</MuiCore.Typography>
                          <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 17}}>1</MuiCore.Typography>
                        </MuiCore.Grid>
                      </MuiCore.Grid>
                    </MuiCore.Grid>
                  </MuiCore.Grid>} */}
            <MuiCore.Grid style={{ width: '100%', textAlign: 'center', margin: '20px 0' }}>
              <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 17 }}>Any applicable partnerships and/or promotions can be viewed on your invoice. Contact us at
                <a href="tel:(866) 611-7829" style={{ color: '#000', textDecoration: 'none' }}> (866) 611-7829</a> or <a href="mailto:staff@ruby.com" style={{ color: '#000', textDecoration: 'none' }}>staff@ruby.com </a>
                to change or modify your current plans.</MuiCore.Typography>
            </MuiCore.Grid>
          </MuiCore.Grid>}
          {this.state.tableValue === 1 && <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
            <MuiCore.Grid lg={6} className={classes.flexContainer}>
              <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 20, marginBottom: 10, textAlign: 'center' }}>{`Balance: ${Formatters.formatMoney(account?.balance, account?.currencyCode)}`}</MuiCore.Typography>
              <MuiCore.Grid container className={classes.leftSide}>
                <MuiCore.TableContainer component={MuiCore.Paper}>
                  <MuiCore.Table stickyHeader>
                    <MuiCore.TableHead>
                      <MuiCore.TableRow className={classes.table}>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Invoice number</MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Status</MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Issue Date</MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Due Date</MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Amount</MuiCore.TableCell>
                        {/* <MuiCore.TableCell style={{fontFamily: 'Sofia-bold'}}>Balance</MuiCore.TableCell> */}
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Download</MuiCore.TableCell>
                      </MuiCore.TableRow>
                    </MuiCore.TableHead>
                    {account.invoices?.map(invoice => {
                      let dueDate = new Date(new Date(invoice.invoiceDate).getTime() +
                        ((account.autopayDays === undefined ? 2 : account.autopayDays + 1) * 24 * 60 * 60 * 1000));
                      let pastDue = new Date() > dueDate && invoice.status === 'OPEN';
                      invoice.status = pastDue ? 'PAST DUE' : invoice.status;
                      return (<MuiCore.TableRow style={{ cursor: 'pointer' }} onClick={() => {
                        this.invoiceClicked(invoice.invoiceId);
                      }}>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>{invoice.invoiceNumber}</MuiCore.TableCell>
                        <MuiCore.TableCell style={{
                          color: invoice.status === 'OPEN' ? '#E81F76' :
                            invoice.status === 'PROCESSING' ? '#E81F76' :
                              invoice.status === 'PAST DUE' ? '#E81F76' :
                                '#32969D', display: 'flex', flexDirection: 'row'
                        }}>
                          <DotIcon />
                          <span style={{ marginTop: 3, fontFamily: 'Sofia' }}>{invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1).toLowerCase()}</span>
                        </MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>{Formatters.formatDate(invoice.invoiceDate)}</MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>{Formatters.formatDate(dueDate.toString())}</MuiCore.TableCell>
                        <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>{Formatters.formatMoney(invoice.debit, invoice.currencyCode)}</MuiCore.TableCell>
                        {/* <MuiCore.TableCell style={{fontFamily: 'Sofia'}}>{Formatters.formatMoney(invoice.runningBalance, invoice.currencyCode)}</MuiCore.TableCell> */}
                        <MuiCore.TableCell><DownloadIcon style={{ cursor: 'pointer' }} onClick={() => { downloadPdfInvoice(invoice.accountId, invoice.invoiceId) }} /></MuiCore.TableCell>
                      </MuiCore.TableRow>)
                    })}
                  </MuiCore.Table>
                </MuiCore.TableContainer>
              </MuiCore.Grid>
              {/* <Statement className={classes.flexItemRoot} /> */}
            </MuiCore.Grid>
          </MuiCore.Grid>}
          {this.state.tableValue === 2 && <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer} style={{ alignItems: 'flex-start' }}>
            {/* <Plans className={classes.flexItemRoot} /> */}

            <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 24, marginBottom: 20, width: '100%' }}>Payment info</MuiCore.Typography>
            
            <MuiCore.Grid container spacing={3} style={{ width: '100%' }}>
              {/* Left Column - Billing Address */}
              <MuiCore.Grid item lg={6} md={6} xs={12}>
                <MuiCore.Grid className={classes.panel}>
                  <MuiCore.Grid style={{ display: 'flex', flexDirection: 'row' }}>
                    <MuiCore.Grid style={{ marginLeft: 20 }} lg={12}>
                      <MuiCore.Grid>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 17 }}>Billing address</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{account.accountName}</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{account.billingAddress1}</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{account.billingAddress2}</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{account.billingCity}, {account.billingUsState}, {account.billingUsZip}</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{account.billingCountryName}</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{account.billingEmail}</MuiCore.Typography>
                        <MuiCore.Typography className={classes.filterText} style={{ fontFamily: 'Sofia-bold', fontSize: 14, marginTop: 15, color: this.state.mouseState === 'edit' ? '#E5196C' : '#7E2062', fontWeight: 400, marginRight: 30 }}>
                          <span style={{ cursor: 'pointer' }} onMouseEnter={() => { this.setState({ mouseState: 'edit' }) }} onMouseLeave={() => { this.setState({ mouseState: 'left' }) }} onClick={() => this.setState({ addressEditOpen: true, editType: 'billing' })}>
                            {'Edit'}
                          </span>
                        </MuiCore.Typography>
                      </MuiCore.Grid>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>

              {/* Right Column - Additional Billing Emails */}
              <MuiCore.Grid item lg={6} md={6} xs={12}>
                <MuiCore.Box className={classes.emailPanel}>
                  <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 17, marginBottom: 8 }}>
                    Additional billing emails
                  </MuiCore.Typography>
                  <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 14, color: '#666', marginBottom: 16 }}>
                    Invoices and payment reminders will be sent to the primary billing email and all additional emails listed below (max 10).
                  </MuiCore.Typography>
                  
                  {/* List of additional billing emails */}
                  {(this.props.billingEmails?.destinations || []).length > 0 ? (
                    <React.Fragment>
                      <MuiCore.Grid container spacing={1} style={{ marginBottom: 8 }}>
                        {(() => {
                          const allEmails = (this.props.billingEmails?.destinations || [])
                            .filter(email => email && email.address);
                          const maxVisible = 3;
                          const hasMore = allEmails.length > maxVisible;
                          const visibleEmails = this.state.showAllBillingEmails ? allEmails : allEmails.slice(0, maxVisible);
                          
                          return visibleEmails.map((email, index) => {
                            const emailId = email.mailingListDestinationId 
                              ? String(email.mailingListDestinationId) 
                              : `email-${index}`;
                            const emailAddress = String(email.address || '');
                            
                            return (
                              <MuiCore.Grid item xs={12} key={emailId}>
                                <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 15 }}>
                                  • {emailAddress}
                                </MuiCore.Typography>
                              </MuiCore.Grid>
                            );
                          });
                        })()}
                      </MuiCore.Grid>
                      
                      {/* Show More/Show Less Button */}
                      {(() => {
                        const allEmails = (this.props.billingEmails?.destinations || []).filter(email => email && email.address);
                        const maxVisible = 3;
                        const hasMore = allEmails.length > maxVisible;
                        
                        return hasMore ? (
                          <MuiCore.Button
                            size="small"
                            onClick={() => this.setState({ showAllBillingEmails: !this.state.showAllBillingEmails })}
                            style={{
                              backgroundColor: '#ffffff',
                              color: '#7E2062',
                              textTransform: 'none',
                              fontFamily: 'Sofia',
                              fontSize: 11,
                              marginBottom: 16,
                              padding: '3px 8px',
                              minWidth: 'auto',
                              border: '1px solid #e0e0e0',
                              borderRadius: '20px',
                              display: 'flex',
                              alignItems: 'center',
                              visibility: 'visible',
                              opacity: 1
                            }}
                          >
                            <span style={{ marginRight: '4px' }}>
                              {this.state.showAllBillingEmails ? '▲' : '▼'}
                            </span>
                            {this.state.showAllBillingEmails 
                              ? 'Show Less' 
                              : `Show More`}
                          </MuiCore.Button>
                        ) : null;
                      })()}
                    </React.Fragment>
                  ) : (
                    <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 14, color: '#999', fontStyle: 'italic', marginBottom: 16 }}>
                      No additional billing emails
                    </MuiCore.Typography>
                  )}

                  {/* EDIT EMAIL Button */}
                  <MuiCore.Button
                    variant="contained"
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => this.setState({ addressEditOpen: true, editType: 'billing' })}
                    style={{
                      backgroundColor: '#7E2062',
                      color: '#fff',
                      textTransform: 'none',
                      fontFamily: 'Sofia-bold',
                      fontSize: 11,
                      padding: '4px 10px',
                      borderRadius: '20px'
                    }}
                  >
                    EDIT EMAIL
                  </MuiCore.Button>
                </MuiCore.Box>
              </MuiCore.Grid>
            </MuiCore.Grid>

            <MuiCore.Grid className={classes.flexContainer} lg={6} style={{ marginTop: 15 }}>
              <MuiCore.Grid className={classes.panel}>
                <MuiCore.Grid container>
                  {paymentMethods?.paymentMethods?.map((method, index) => (<MuiCore.Grid item xs={4} md={4} lg={4} style={{ marginTop: 20 }}>
                    {method.type !== 'us_bank_account' && <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 17 }}>
                        {method.card?.funding?.toUpperCase()}
                        {account.autopayPaymentMethodUid === method.id && <span style={{ backgroundColor: '#EF9BA2', borderRadius: 20, marginLeft: 10, color: '#FFF', fontSize: 13, padding: 3, paddingLeft: 5, paddingRight: 5 }}>Default</span>}
                        {/* {account.autopayPaymentMethodUid === method.id && <span style={{borderRadius: 20, marginLeft: 10, color: '#7f2062', padding: 3, paddingLeft: 5, paddingRight: 5}}>
                                  <MuiCore.Tooltip title='This is your default payment method for payments. To remove the current default payment method, please add another payment method and click "Make default".' classes={{ tooltip: classes.tooltip }}>
                                    <InfoIcon style={{fontSize: 19}}/>
                                  </MuiCore.Tooltip>
                                </span>} */}
                      </MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{Formatters.formatPaymentMethod(method).number}</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{method?.billing_details?.name}</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>Expiration Date: {Formatters.formatPaymentMethod(method).exp}</MuiCore.Typography>
                      {/* <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 17}}>{Formatters.formatPaymentMethod(method).brand}</MuiCore.Typography> */}
                      {/* {account.autopayPaymentMethodUid !== method.id &&  */}
                      <>
                        <MuiCore.Typography className={classes.filterText} style={{ fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'makeDefault' + index ? '#E5196C' : '#7E2062', fontWeight: 400, marginRight: 30 }}>
                          <span style={{ cursor: 'pointer' }} onMouseEnter={() => { this.setState({ mouseState: 'makeDefault' + index }) }} onMouseLeave={() => { this.setState({ mouseState: 'left' }) }} onClick={() => {
                            if (account.autopayPaymentMethodUid === method.id) {
                              this.props.postSnackMessage('error', 'This is already your default payment method.');
                              return;
                            } else {
                              enableAutopay(account.accountId, method.id)
                            }
                          }}>
                            {'Make default'}
                          </span>
                        </MuiCore.Typography>
                        <MuiCore.Typography className={classes.filterText} style={{ fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'removeMethod' + index ? '#E5196C' : '#7E2062', fontWeight: 400, marginRight: 30 }}>
                          <span style={{ cursor: 'pointer' }} onMouseEnter={() => { this.setState({ mouseState: 'removeMethod' + index }) }} onMouseLeave={() => { this.setState({ mouseState: 'left' }) }} onClick={() => {
                            if (account.autopayPaymentMethodUid === method.id) {
                              this.props.postSnackMessage('error', 'This is your default payment method. To remove this payment method, first replace it with a different payment method. Then come back to remove this payment method.');
                              return;
                            } else {
                              deletePaymentMethod(account.accountId, method.id)
                            }
                          }}>
                            {'Remove payment method'}
                          </span>
                        </MuiCore.Typography>
                      </>
                      {/* } */}
                      {/* {account.autopayPaymentMethodUid === method.id && 
                              <>
                                <MuiCore.Typography className={classes.filterText} style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'removeMethod'+index ? '#E5196C' : '#7E2062', fontWeight: 400, marginRight: 30}}>
                                  <span style={{cursor: 'pointer'}} onMouseEnter={()=>{this.setState({mouseState: 'removeMethod' + index})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}} onClick={() => deletePaymentMethod(account.accountId, method.id)}>
                                    {'Remove Payment Method'}
                                  </span>
                                </MuiCore.Typography>
                              </>} */}
                    </MuiCore.Grid>}
                    {method.type === 'us_bank_account' && <MuiCore.Grid>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', fontSize: 17 }}>
                        {method.us_bank_account?.account_type?.toUpperCase()}
                        {account.autopayPaymentMethodUid === method.id && <span style={{ backgroundColor: '#EF9BA2', borderRadius: 20, marginLeft: 10, color: '#FFF', fontSize: 13, padding: 3, paddingLeft: 5, paddingRight: 5 }}>Default</span>}
                        {/* {account.autopayPaymentMethodUid === method.id && <span style={{borderRadius: 20, marginLeft: 10, color: '#7f2062', padding: 3, paddingLeft: 5, paddingRight: 5}}>
                                  <MuiCore.Tooltip title='You must set a new default payment method before removing the current one' classes={{ tooltip: classes.tooltip }}>
                                    <InfoIcon style={{fontSize: 19}}/>
                                  </MuiCore.Tooltip>
                                </span>} */}
                      </MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{Formatters.formatPaymentMethod(method).number}</MuiCore.Typography>
                      {/* <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 17}}>Expiration Date: {Formatters.formatPaymentMethod(method).exp}</MuiCore.Typography> */}
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{method?.billing_details?.name}</MuiCore.Typography>
                      <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 17 }}>{Formatters.formatPaymentMethod(method).brand}</MuiCore.Typography>
                      {/* {account.autopayPaymentMethodUid !== method.id &&  */}
                      <>
                        <MuiCore.Typography className={classes.filterText} style={{ fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'makeDefault' + index ? '#E5196C' : '#7E2062', fontWeight: 400, marginRight: 30 }}>
                          <span style={{ cursor: 'pointer' }} onMouseEnter={() => { this.setState({ mouseState: 'makeDefault' + index }) }} onMouseLeave={() => { this.setState({ mouseState: 'left' }) }} onClick={() => {
                            if (account.autopayPaymentMethodUid === method.id) {
                              this.props.postSnackMessage('error', 'This is already your default payment method.');
                              return;
                            } else {
                              enableAutopay(account.accountId, method.id)
                            }
                          }}>
                            {'Make default'}
                          </span>
                        </MuiCore.Typography>
                        <MuiCore.Typography className={classes.filterText} style={{ fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'removeMethod' + index ? '#E5196C' : '#7E2062', fontWeight: 400, marginRight: 30 }}>
                          <span style={{ cursor: 'pointer' }} onMouseEnter={() => { this.setState({ mouseState: 'removeMethod' + index }) }} onMouseLeave={() => { this.setState({ mouseState: 'left' }) }} onClick={() => {
                            if (account.autopayPaymentMethodUid === method.id) {
                              this.props.postSnackMessage('error', 'This is your default payment method. To remove this payment method, first replace it with a different payment method. Then come back to remove this payment method.');
                              return;
                            } else {
                              deletePaymentMethod(account.accountId, method.id)
                            }
                          }}>
                            {'Remove payment method'}
                          </span>
                        </MuiCore.Typography>
                      </>
                      {/* } */}
                    </MuiCore.Grid>}
                  </MuiCore.Grid>))}
                </MuiCore.Grid>
                {/* <MuiCore.Typography style={{marginTop: 10}}>
                          *Default Payment methods cannot be deleted
                        </MuiCore.Typography> */}
                <MuiCore.Button style={{ fontFamily: 'Sofia', marginTop: 20, fontWeight: 700 }} onClick={() => this.setState({ confirmAddPaymentOpen: true })}>
                  <AddIcon />
                  Add Payment Method
                </MuiCore.Button>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>}
        </div>


      </MuiCore.Grid>
      )
  }
}

const mapStateToProps = (state) => {
  return ({
    account: accountSelectors.getAccount(state),
    paymentMethods : accountSelectors.getPaymentMethods(state),
    invoice: accountSelectors.getInvoice(state),
    billingEmails: accountSelectors.getBillingEmails(state)
  });
};

const mapDispatchToProps = {
  setInvoiceOpen : accountActions.setInvoiceOpen,
  queryPaymentMethods : accountActions.queryPaymentMethods,
  queryInvoice : accountActions.queryInvoice,
  redirectToAddPayment : accountActions.redirectToAddPayment,
  downloadPdfInvoice: accountActions.downloadPdfInvoice,
  enableAutopay: accountActions.enableAutopay,
  queryAccount: accountActions.queryAccount,
  openCheckoutSession: accountActions.openCheckoutSession,
  deletePaymentMethod: accountActions.deletePaymentMethod,
  postSnackMessage: coreActions.postSnackMessage,
  queryBillingEmails: accountActions.queryBillingEmails
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(Account)));

